import React from 'react'
import ReactPaginate from 'react-paginate';
export default function Pagination({pageCount, handlePageClick, currentPage = 0}) {
  return (
    <div>
        <ReactPaginate
                pageCount={pageCount}
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                onPageChange={handlePageClick}
                forcePage={currentPage}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
    </div>
  )
}
